<template>
   <div>
      <h6>Cadastrar conta bancária</h6>
      <hr>
      <el-form
         :model="bankAccount"
         :rules="bankAccountRules"
         ref="bankAccount"
         class="bordered checkout-form dashboard-form pl-1 pr-1"
         size="small"
         label-position="top"
      >

         <el-row :gutter="20">

            <!-- Referente ao radio -->
            <el-col :span="24" v-if="false">
               <el-form-item label="Referente ao" prop="holder">
                  <el-radio-group v-model="bankAccount.holder">
                     <el-radio label="sameHolder">Mesmo Titular</el-radio>
                     <el-radio label="otherOwnership">Outra Titularidade</el-radio>
                  </el-radio-group>
               </el-form-item>
            </el-col>

            <!-- Nome titular da conta -->
            <el-col :span="24" :sm="8">
               <el-form-item label="Nome do Titular da Conta" prop="holderName">
                  <el-input v-model="bankAccount.holderName"></el-input>
               </el-form-item>
            </el-col>

            <!-- document -->
            <el-col :span="24" :sm="8">
               <el-form-item :label="isPJ ? 'CNPJ': 'CPF'">
                  <el-input
                     disabled
                     ref="document"
                     type="text"
                     v-model="bankAccount.document"
                  ></el-input>
               </el-form-item>
            </el-col>

            <!-- CPF conta PJ -->
            <el-col v-if="isPJ" :span="24" :sm="8">
               <el-form-item label="CPF" prop="companyOwnerCpf">
                  <el-input
                     ref="companyOwnerCpf"
                     type="text"
                     v-mask="'###.###.###-##'"
                     v-model="bankAccount.companyOwnerCpf"
                  ></el-input>
               </el-form-item>
            </el-col>

            <!-- Tipo de empresa select -->
            <el-col v-if="isPJ" :span="24" :sm="8">
               <el-form-item label="Tipo de Empresa" prop="companyType">
                  <v-select
                     :clearable="false"
                     :options="companyType"
                     v-model="bankAccount.companyType"
                     placeholder="Selecione..."
                  >
                  </v-select>
               </el-form-item>
            </el-col>


            <el-col v-if="isPJ && requireCompMembers()" :span="24" :sm="8">
               <el-form-item
                  style="padding-bottom: 12px;"
                  label="* Quadro Societário"
                  prop="companyMembers">
                  <el-button
                     @click="dialogCompanyMembers = true"
                     :type="companyMembersState ? 'warning' : 'blue'"
                     size="mini"
                     class="text-uppercase font-weight-bold w-100"
                  >
                     Adicionar Sócio ({{ bankAccount.companyMembers.length }})
                  </el-button>
               </el-form-item>
            </el-col>


            <!-- CNAE -->
            <el-col v-if="isPJ" :span="24" :sm="8">
               <el-form-item label="CNAE (Somente números)" prop="cnae">
                  <el-input
                     v-mask="'##.##-#/##'"
                     ref="cnae"
                     v-model="bankAccount.cnae"
                  ></el-input>
               </el-form-item>
            </el-col>

            <!-- renda mensal -->
            <el-col :span="24" :sm="isPJ ? 8 : 8">

               <el-form-item :label="isPJ ? 'Receita Mensal' : 'Renda Mensal'"
                             prop="monthlyIncomeOrRevenue">
                  <money
                     :class="'fake-input'"
                     v-model="bankAccount.monthlyIncomeOrRevenue"
                     v-bind="money">
                  </money>
               </el-form-item>

            </el-col>

            <el-col v-if="isPJ" :span="24" :sm="8">
               <el-form-item label="Data de abertura da empresa" prop="establishmentDate">
                  <el-input
                     v-mask="'##/##/####'"
                     v-model="bankAccount.establishmentDate"
                     placeholder="dd/mm/aaaa"/>
               </el-form-item>
            </el-col>


            <!-- nome da mae -->
            <el-col :span="24" :sm="!requireCompMembers() && isPJ ? 16: 8">
               <el-form-item label="Nome da Mãe" prop="legalRepresentative.motherName">
                  <el-input
                     type="text"
                     v-model="bankAccount.legalRepresentative.motherName"
                  ></el-input>
               </el-form-item>
            </el-col>

            <!-- Tipo de Pessoa  radio -->
            <el-col :span="24" v-if="false">
               <el-form-item label="Tipo de Pessoa (Titular)" prop="type">
                  <el-radio-group v-model="bankAccount.type">
                     <el-radio label="pf">Pessoa Física</el-radio>
                     <el-radio label="pj">Pessoa Jurídica</el-radio>
                  </el-radio-group>
               </el-form-item>
            </el-col>

            <!-- Banco select -->
            <el-col :span="24" :sm="isPJ ? 24 : 16">
               <el-form-item label="Banco" prop="bank">
                  <v-select
                     :clearable="false"
                     :options="banksOptions"
                     @search:focus="getBanks"
                     v-model="bankAccount.bank"
                     placeholder="Selecione..."
                  >
                     <template #no-options="{ search, searching, loading }">
                        <i class="el-icon-loading "></i>
                     </template>
                  </v-select>
               </el-form-item>
            </el-col>

         </el-row>

         <el-row :gutter="20">
            <!-- Agencia -->
            <el-col :span="24" :sm="12">
               <el-row>
                  <el-form-item label="Agencia" prop="agency">

                     <el-col :span="24">
                        <el-input v-model="bankAccount.agency"></el-input>
                     </el-col>

                  </el-form-item>
               </el-row>
            </el-col>

            <!-- Conta -->
            <el-col :span="24" :sm="12">
               <el-row>
                  <el-form-item label="Conta" prop="account">

                     <el-col :span="15">
                        <el-input v-model="bankAccount.account"></el-input>
                     </el-col>

                     <el-col :span="2" class="pt-2 pt-md-0">
                        <div class="text-center">-</div>
                     </el-col>

                     <el-col :span="7">

                        <el-input v-model="bankAccount.accountDigit"></el-input>
                     </el-col>

                  </el-form-item>
               </el-row>

            </el-col>


            <!-- Operação (somente se selecionado caixa) -->
            <el-col v-if="isCaixa" :span="24">
               <el-form-item label="Operação" prop="operation">
                  <v-select
                     :clearable="false"
                     :options="operationOptions"
                     v-model="bankAccount.operation"
                     placeholder="Selecione..."
                  >
                     <template #no-options="{ search, searching, loading }">
                        <i class="el-icon-loading "></i>
                     </template>
                  </v-select>
               </el-form-item>
            </el-col>


            <!-- Tipo de conta -->
            <el-col :span="24">
               <el-form-item label="Tipo" prop="accountType">

                  <v-select
                     :clearable="false"
                     :options="accountTypeOptions"
                     v-model="bankAccount.accountType"
                     placeholder="Selecione..."
                  >
                     <template #no-options="{ search, searching, loading }">
                        <i class="el-icon-loading "></i>
                     </template>
                  </v-select>
               </el-form-item>
            </el-col>

            <!-- salvar -->
            <el-col :xs="8" :sm="12" :md="8" :lg="8">
               <el-button
                  @click="submitForm('bankAccount')"
                  :round="true"
                  :loading="loading.btnSaveAccount"
                  type="primary"
                  size="mini"
                  class="text-uppercase font-weight-bold w-100"
               >
                  Salvar
               </el-button>
            </el-col>

         </el-row>

      </el-form>

      <el-dialog
         v-if="isPJ"
         title="Quadro Societário"
         :visible.sync="dialogCompanyMembers">
         <el-form
            :model="companyMembersForm"
            :rules="companyMembersFormRules"
            class="checkout-form dashboard-form pl-1 pr-1"
            size="small"
            label-position="top"
            ref="companyMembers"
         >

            <el-row :gutter="20">
               <!-- Nome -->
               <el-col :span="24" :sm="8">
                  <el-form-item label="Nome" prop="name">
                     <el-input v-model="companyMembersForm.name"/>
                  </el-form-item>
               </el-col>

               <el-col :span="24" :sm="8">

                  <el-form-item label="CPF" prop="document">
                     <el-input
                        v-mask="'###.###.###-##'"
                        v-model="companyMembersForm.document"/>
                  </el-form-item>
               </el-col>

               <el-col :span="24" :sm="8">

                  <el-form-item label="Data de Nascimento" prop="birthDate">
                     <el-input
                        v-mask="'##/##/####'"
                        v-model="companyMembersForm.birthDate"/>
                  </el-form-item>
               </el-col>
            </el-row>
            <el-button type="primary" size="mini" @click="addNewCompanyMembers('companyMembers')">+ Adicionar
            </el-button>

         </el-form>

         <hr>

         <el-row>
            <el-col :cols="24" v-if="bankAccount.companyMembers.length">
               <el-table :data="bankAccount.companyMembers">
                  <el-table-column property="name" label="Nome"></el-table-column>
                  <el-table-column property="document" label="CPF">
                     <template slot-scope="scope">
                        <input
                           class="border-0 bg-transparent text-muted"
                           readonly=""
                           v-mask="'###.###.###-##'"
                           :value="scope.row.document">
                     </template>
                  </el-table-column>
                  <el-table-column property="birthDate" label="Data de Nascimento"></el-table-column>
                  <el-table-column align="right" label="Remover" width="100px">

                     <template slot-scope="scope">
                        <el-button
                           title="Remover"
                           plain
                           size="mini"
                           type="danger"
                           class="py-1 px-2"

                           @click="deleteCompanyMember(scope.row)">X
                        </el-button>
                     </template>
                  </el-table-column>


               </el-table>
            </el-col>
         </el-row>

         <div class="text-left pt-3">
           <span v-if="bankAccount.companyMembers.length" slot="footer" class="dialog-footer">
             <el-button type="blue" class="px-5" size="mini" @click="closeDialogCompanyMembers()">Salvar</el-button>
           </span>
         </div>

      </el-dialog>
   </div>
</template>

<script>
import bankAccount from "@/models/BankAccount";
import {Money, VMoney} from 'v-money';
import {mask} from "vue-the-mask";
import numeral from "numeral";
import isCpf from "@/helpers/cpf";
import {formatUSADate, onlyNumber} from "@/helpers";
import PaymentService from "@/services/payment";
import UserService from '@/services/user.service'

export default {
   comments: {
      Money,
   },
   directives: {
      mask,
      money: VMoney
   },
   props: {
      isChild: {
         type: Boolean,
         default: false
      },
      step: {
         type: String,
         default: '',
         required: false
      },
   },
   data() {
      return {
         user: {},
         bankAccount,
         digitalAccount: {},
         bankAccountRules: {
            holder: [
               {required: true, message: 'Selecione uma opção', trigger: 'blur'},
            ],
            holderName: [
               {required: true, message: 'Digite seu nome do titular', trigger: 'blur'},
            ],
            type: [
               {required: true, message: 'Selecione uma opção', trigger: 'blur'},
            ],
            companyOwnerCpf: [
               {required: true, message: 'Digite seu CPF', trigger: 'blur'},
               {validator: this.checkCpf, trigger: 'blur'},
            ],
            companyType: [
               {required: true, message: 'Selecione o tipo de empresa', trigger: 'blur'},
            ],
            bank: [
               {required: true, message: 'Selecione um banco', trigger: 'blur'},
            ],
            agency: [
               {required: true, message: 'Digite o número da agencia', trigger: 'blur'},
            ],
            account: [
               {required: true, message: 'Digite o número da conta', trigger: 'blur'},
            ],
            accountType: [
               {required: true, message: 'Selecione o tipo da conta', trigger: 'blur'},
            ],
            operation: [
               {validator: this.checkOperation, trigger: 'blur'},
            ],
            legalRepresentative: {
               motherName: {required: true, message: 'O nome da mãe é obrigatório', trigger: 'blur'},
            },
            monthlyIncomeOrRevenue: [
               {required: true, validator: this.monthlyIncomeOrRevenueRule, trigger: 'blur'},
            ],
            cnae: [
               {required: true, message: 'Informe o Cnae principal', trigger: 'blur'},
            ],
            establishmentDate: [
               {required: true, validator: this.checkDate, trigger: 'blur'},
            ],
         },
         banksOptions: [],
         companyType: [
            {value: "MEI", label: "MEI"},
            {value: "EI", label: "EI"},
            {value: "EIRELI", label: "EIRELI"},
            {value: "LTDA", label: "LTDA"},
            {value: "SA", label: "SA"},
            {value: "INSTITUITION_NGO_ASSOCIATION", label: "ONG"}
         ],
         accountTypeOptions: [
            {value: 'CHECKING', label: 'Conta Corrente'},
            {value: 'SAVINGS', label: 'Conta Poupança'},
         ],
         operationOptions: [
            {value: "001", label: "001 - Conta Corrente de Pessoa Física"},
            {value: "002", label: "002 - Conta Simples de Pessoa Física"},
            {value: "003", label: "003 - Conta Corrente de Pessoa Jurídica"},
            {value: "013", label: "013 - Poupança de Pessoa Física"},
            {value: "022", label: "022 - Poupança de Pessoa Jurídica"},
            {value: "023", label: "023 - Conta Caixa Fácil"},
            {value: "028", label: "028 - Poupança de Crédito Imobiliário"},
            {value: "032", label: "032 - Conta Investimento Pessoa Física"},
            {value: "034", label: "034 - Conta Investimento Pessoa Jurídica"}
         ],
         isCaixa: false,
         loading: {
            btnSaveAccount: false,
            bankList: true,
         },
         otherOwnership: false,
         money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            precision: 2,
            masked: false /* doesn't work with directive */
         },
         dialogCompanyMembers: false,
         companyMembersForm: {
            id: null,
            name: '',
            document: '',
            birthDate: ''
         },
         companyMembersFormRules: {
            name: [
               {required: true, message: 'Digite o nome', trigger: 'blur'},
            ],
            document: [
               {required: true, message: 'Digite seu CPF', trigger: 'blur'},
               {validator: this.checkCpf, trigger: 'blur'},
            ],
            birthDate: [
               {required: true, validator: this.checkDate, trigger: 'blur'},
            ],
         },
         companyMembersState: false,
         url: `/painel/anunciante/minhas-bicicletas/bicicleta/`
      }
   },
   async mounted() {
      await this.getUser();
      this.user = this.userData.data

      if (this.user) {
         this.bankAccount.holderName = this.isPJ ?
            this.user.additionalInformation.corporateName :
            `${this.user.firstName} ${this.user.lastName}`

         this.bankAccount.document = this.user.additionalInformation.cpf
         if (this.user.bankAccount.length) {
            this.updateBankAccountLocalData()
         }
      }

   },
   methods: {
      async getUser() {
         await this.$store.dispatch('user/get', await UserService.getUserData())
      },

      async getBanks() {

         if (this.banksOptions.length === 0) {
            const pay = await PaymentService.Data('banks');

            let arr = []

            pay.map(v => {
               arr.push({value: v.number, label: v.name})
            })
            this.banksOptions = arr;
         }
      },

      checkCpf(rule, value, callback) {

         if (!value) {
            return callback(new Error('Por favor, digite seu CPF'));
         }

         const cpf = value.replace(/\./g, "").replace(/-/, "");

         if (!isCpf(cpf)) {
            return callback(new Error('CPF Inválido'));
         }

         callback();
      },

      checkOperation(rule, value, callback) {

         if (!value && this.isCaixa) {
            return callback(new Error('Selecione a Operação'));
         }

         callback();
      },

      handleSetOperation() {
         if (this.bankAccount.operation.value) {
            return this.bankAccount.operation.value
         }
         if (this.bankAccount.operation) {
            return this.bankAccount.operation
         }
         if (!this.bankAccount.operation.value && !this.bankAccount.operation ){
            return ''
         }
      },

      submitForm(formName) {
         this.$refs[formName].validate((valid) => {
            this.loading.btnSaveAccount = true;

            if (valid) {

               try {
                  if (this.requireCompMembers() && !this.bankAccount.companyMembers.length) {
                     this.$message({
                        message: "Preencha o Quadro Societario!",
                        type: 'error'
                     });
                     this.companyMembersState = true
                     this.loading.btnSaveAccount = false;
                     return false
                  }

                  const data = {
                     account: this.bankAccount.account,
                     accountDigit: this.bankAccount.accountDigit,
                     accountType: this.bankAccount.accountType.value || this.bankAccount.accountType,
                     agency: this.bankAccount.agency,
                     agencyDigit: this.bankAccount.agencyDigit,
                     bank: this.bankAccount.bank.value || this.bankAccount.bank,
                     bankName: this.bankAccount.bank.label || this.bankAccount.bankName,
                     document: this.bankAccount.document,
                     holder: this.bankAccount.holder,
                     holderName: this.bankAccount.holderName,
                     operation: this.handleSetOperation(),
                     type: this.user.additionalInformation.type,
                     _id: this.bankAccount._id,
                     legalRepresentative: {
                        motherName: this.bankAccount.legalRepresentative.motherName
                     },
                     monthlyIncomeOrRevenue: this.bankAccount.monthlyIncomeOrRevenue,
                     companyOwnerCpf: this.bankAccount.companyOwnerCpf ? onlyNumber(this.bankAccount.companyOwnerCpf) : '',
                     companyType: this.bankAccount.companyType ? this.bankAccount.companyType : {},
                     cnae: this.bankAccount.cnae ? onlyNumber(this.bankAccount.cnae) : '',
                     establishmentDate: this.isPJ ? formatUSADate(this.bankAccount.establishmentDate) : formatUSADate(this.user.additionalInformation.dateOfBirth),
                     companyMembers: this.bankAccount.companyMembers.length ?
                        this.bankAccount.companyMembers.map(m => (
                        {
                           name: m.name,
                           document: m.document,
                           birthDate: formatUSADate(m.birthDate)
                        })) : []
                  }

                  delete this.bankAccount.createdAt;
                  delete this.bankAccount.updatedAt;

                  //Se tiver alguma conta, pega o index 0, se não, é null. Dependendo de qual estado
                  // posta uma conta ou atualiza uma, pois o método é outro na api
                  UserService.postBankAccount(data, this.user.bankAccount.length)
                     .then((response) => {
                        this.$message({
                           message: response.data.message,
                           type: 'success'
                        });
                        this.loading.btnSaveAccount = false;
                        this.editingAccount = ''
                        this.editing = null
                        this.isEdit = false

                        if (!this.isChild) {
                           this.goTo('/painel/anunciante/minhas-bicicletas')
                        }

                     })
                     .catch(() => {
                        this.loading.btnSaveAccount = false;
                     });
               } catch (e) {
                  this.loading.btnSaveAccount = false;
                  this.$message.error("Serviço indisponível. Tente novamente mais tarde.");
               }

            } else {
               this.$message.error("Atenção, um ou mais campos com problemas.");
               this.loading.btnSaveAccount = false;
               return false;
            }
         });
      },

      resetForm(formName) {
         this.$refs[formName].resetFields();
         this.bankAccount.holderName = `${this.user.firstName} ${this.user.lastName}`
         this.bankAccount.document = this.user.additionalInformation.cpf
         this.bankAccount.agencyDigit = '';
         this.bankAccount.accountDigit = '';
         this.bankAccount._id = '';
      },

      monthlyIncomeOrRevenueRule(rule, value, callback) {

         let formatedPrice = numeral(value);

         if (formatedPrice._value < 0) {
            this.netValue = numeral(0.00).format('$ 0,0.00');
         }

         if (!formatedPrice._value || formatedPrice._value === 0.00) {
            return callback(new Error('Informe sua renda!'));
         }

         callback();

      },

      checkDate(rule, value, callback) {

         if (!value) {
            return callback(new Error('Informe a data de abertura'));
         }

         if (value.length !== 10) {
            callback(new Error('Digite a data corretamente'));
         }

         const dateBirth = value.split('/');
         const day = dateBirth[0];
         const month = dateBirth[1];
         const year = dateBirth[2];

         if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1000) {
            callback(new Error('Data inválida'));
         }


         callback();
      },

      addNewCompanyMembers(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
               let data = this.companyMembersForm;
               let doc = onlyNumber(this.companyMembersForm.document);

               data.document = doc
               data.id = new Date().getTime();
               data.birthDate = this.companyMembersForm.birthDate

               this.bankAccount.companyMembers.push(JSON.parse(JSON.stringify(data)))
               this.$refs[formName].resetFields();
            } else {
               this.$message.error("Atenção, um ou mais campos possum algum problema.");
               return false;
            }
         });
      },

      deleteCompanyMember(row) {
         let data = this.bankAccount.companyMembers
         this.bankAccount.companyMembers = data.filter(f => f.id !== row.id)
      },

      closeDialogCompanyMembers() {
         this.companyMembersState = false;
         this.dialogCompanyMembers = false
      },

      requireCompMembers() {
         if (!this.bankAccount.companyType) return  false
         if (this.bankAccount.companyType) {
            return this.bankAccount.companyType.value === 'LTDA' || this.bankAccount.companyType.value === 'SA'
         }
      },

      updateBankAccountLocalData() {
         const bankAccount = this.user.bankAccount[0]
         const establishmentDate = bankAccount.establishmentDate ?
            this.$moment(new Date(bankAccount.establishmentDate), 'DD/MM/YYYY') :
            null

         this.bankAccount._id = bankAccount._id
         this.bankAccount.holderName = bankAccount.holderName
         this.bankAccount.holder = bankAccount.holder
         this.bankAccount.type = bankAccount.type
         this.bankAccount.document = bankAccount.document
         this.bankAccount.bank = {value: bankAccount.bank, label: bankAccount.bankName}
         this.bankAccount.agency = bankAccount.agency
         this.bankAccount.agencyDigit = bankAccount.agencyDigit
         this.bankAccount.account = bankAccount.account
         this.bankAccount.accountDigit = bankAccount.accountDigit
         this.bankAccount.accountType = (() => {
            if (bankAccount.accountType === 'CHECKING') return {value: 'CHECKING', label: 'Conta Corrente'}
            if (bankAccount.accountType === 'SAVINGS') return {value: 'SAVINGS', label: 'Conta Poupança'}
         })()
         this.bankAccount.operation = bankAccount.operation
         this.bankAccount.legalRepresentative = bankAccount.legalRepresentative
         this.bankAccount.monthlyIncomeOrRevenue = bankAccount.monthlyIncomeOrRevenue
         this.bankAccount.companyOwnerCpf = bankAccount.companyOwnerCpf
         this.bankAccount.companyType = bankAccount.companyType
         this.bankAccount.cnae = bankAccount.cnae
         this.bankAccount.establishmentDate = establishmentDate.format('DD/MM/YYYY')
         this.bankAccount.companyMembers = bankAccount.companyMembers
      },

      goTo(url) {
         this.$router.push(url);
      },
   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      userData() {
         return this.$store.state.user
      },
      isPJ() {
         return this.$store.state.user.data.additionalInformation.type === 'pj' || false
      },
      isSendDocuments() {
         return this.documentsList.filter(f => f.approvalStatus !== 'APPROVED' && f.approvalStatus !== 'VERIFYING')
      },
      allApproved() {
         return this.documentsList.filter(f => f.approvalStatus !== 'APPROVED' && f.approvalStatus !== 'VERIFYING')
      }
   },
   watch: {
      'bankAccount.bank': function (n) {

         this.isCaixa = n.value === '104';

         this.banksOptions.map(v => {
            if (v.value === n) {
               this.bankAccount.bankName = v.label
            }
         })
      },
      'bankAccount.document': function (n) {
         this.bankAccount.document = onlyNumber(n)
      },
      'bankAccount.holder': function (n) {
         this.otherOwnership = n === "otherOwnership"
         if (this.isEdit) {
            if (this.otherOwnership) {
               this.bankAccount.holderName = this.tempObj.holderName
               this.bankAccount.document = this.tempObj.document
            } else {
               this.bankAccount.holderName = `${this.user.firstName} ${this.user.lastName}`
               this.bankAccount.document = this.user.additionalInformation.cpf
            }

         } else {
            if (this.otherOwnership) {
               this.bankAccount.holderName = ''
               this.bankAccount.document = ''
            } else {
               this.bankAccount.holderName = `${this.user.firstName} ${this.user.lastName}`
               this.bankAccount.document = this.user.additionalInformation.cpf
            }
         }
      },
   }
}
</script>

<style lang="scss">
   .finalize-register {
      .dashboard-card {
         overflow: visible !important;
      }
   }
</style>
